import { useState, useContext } from "react";
import logo from "../../../assets/images/sidebar-logo.png";
import mobileLogo from "../../../pages/Viewer/Images/logo.png";
import RightNavControls from "./RightNavControls";
import HeaderTopVCControls from "./HeaderTopVCControls";
import { useConferenceCommands } from "../hooks/useConferenceCommands";
import useAutoLogout from "../../../pages/ZoomViewer/hooks/useAutoLogout";
import { Grid } from "antd";
import { get } from "../../../utils/helpers";
import trayRightIcon from "../../../pages/Viewer/Images/tray-right-icon.svg";
import ham from '../../../pages/Viewer/Images/hamburger-menu.svg';
import closeImg from "../../../pages/Viewer/Images/close.svg";
import { AppMenu } from "../../AppMenu";
import { AuthContext } from "../../../context/auth";

const { useBreakpoint } = Grid;

const ZoomHeaderView = (props: any) => {
  const {
    admin_user_id,
    adminAccessCode,
    role,
    room_code,
    room_id,
    onScreenShareClick,
    editorDirectLogin
  } = props;

  const screens = useBreakpoint();
  const isMobile = get(screens, 'xs', false);
  const [rightNavModalOpen, setRightNavModalOpen] = useState(false);
  const userLoggedIn: any = useContext(AuthContext);
  const isGuestViewer = get(userLoggedIn,'guestViewer',false);

  useAutoLogout(admin_user_id)
  const { handelVideoConfEnd } = useConferenceCommands(
    room_code,
    room_id,
    admin_user_id
  );

  // Use mobile logo on mobile, desktop logo on desktop
  const logoToShow = isMobile ? mobileLogo : logo;

  return (
    <div className="topbar">
      {/* Left  Logo*/}
      <div className="logo-viewer">
        <img src={logoToShow} alt="logo" style={{ margin: "15px 0 0 15px" }} />
      </div>
      {/* Top VC Controls*/}
      <div className="centerMenuTop">
        <HeaderTopVCControls
          admin_user_id={admin_user_id}
          adminAccessCode={adminAccessCode}
          role={role}
          room_code={room_code}
          room_id={room_id}
          onScreenShareClick={onScreenShareClick}
          onMenuOpen={() => setRightNavModalOpen(false)}
        />
        {/* Hamburger menu for Chat and Guest */}
        {isMobile && !isGuestViewer && (
          <div
            className="top-menu-button-item overflow-rightmenu-trigger-mobile"
            onClick={() => {
              const newState = !rightNavModalOpen;
              setRightNavModalOpen(newState);
              // Close annotation menu when right nav opens (not when closing)
              if (newState) {
                const event = new CustomEvent('closeAnnotationMenu');
                window.dispatchEvent(event);
              }
            }}
            style={{ position: 'relative' }}
          >
            <img 
              src={rightNavModalOpen ? closeImg : ham} 
              alt='' 
              style={{ filter: 'brightness(1)', width: '20px', height: '20px' }} 
            />
            
            {rightNavModalOpen && (
              <div className="overflow-menu-dropdown mobile-right-menu">
                <div className="overflow-menu-content right-nav-horizontal">
                  <RightNavControls 
                    handelVideoConfEnd={handelVideoConfEnd} 
                    editorDirectLogin={editorDirectLogin}
                    excludeAppMenu={true}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Right Nav Controls - Desktop: top bar, Mobile: separate hamburger menu + AppMenu outside */}
      {isMobile && !isGuestViewer ? (
        <>
          
          {/* AppMenu outside hamburger menu on mobile */}
          {!!userLoggedIn && (
            <div className="menuTopRight">
              <ul>
                <li>
                  <div className="zoom-header-menu">
                    <AppMenu
                      className="header-menu"
                      zoomClient={true}
                      isViewer={true}
                      handelVideoConfEnd={handelVideoConfEnd}
                      editorDirectLogin={editorDirectLogin}
                    />
                  </div>
                </li>
              </ul>
            </div>
          )}
        </>
      ) : (
        <div className="menuTopRight">
          <RightNavControls handelVideoConfEnd={handelVideoConfEnd} editorDirectLogin={editorDirectLogin}/>
        </div>
      )}
    </div>
  );
};

export default ZoomHeaderView;
